import { render, staticRenderFns } from "./site-list.component.vue?vue&type=template&id=8cba0cc4"
import script from "./site-list.component.ts?vue&type=script&lang=ts&external"
export * from "./site-list.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-list.component.vue?vue&type=style&index=0&id=8cba0cc4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cba0cc4')) {
      api.createRecord('8cba0cc4', component.options)
    } else {
      api.reload('8cba0cc4', component.options)
    }
    module.hot.accept("./site-list.component.vue?vue&type=template&id=8cba0cc4", function () {
      api.rerender('8cba0cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site-list/site-list.component.vue"
export default component.exports